export default __webpack_public_path__ + "static/IN-9008HD-vs-IN-5905HD_day2-55e97227aa5dce1eb5d3ecf66b18f77e.webp";